import { MessageType } from '@/types/common';
import { createAppSlice } from '../createAppSlice';
import { PAGINATION } from '@/constants/pagination.constant';
import { transformerArray } from '../transformer';

type UserSliceState = {
  loading: boolean;
  listUserClient: User[];
  listActivityLogsUserClient: ActivityLog[];
  message?: MessageType;
  pagination: Pagination;
};

const initialState: UserSliceState = {
  loading: false,
  listUserClient: [],
  listActivityLogsUserClient: [],
  pagination: PAGINATION
};

export const clientUserSlice = createAppSlice({
  name: 'user',
  initialState,
  reducers: (create) => ({
    getListUserClient: create.asyncThunk(
      async (query?: Record<string, any>) => {
        const response = await apiFetcher.post('user/client', query);
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listUserClient = transformerArray(action.payload.listData);
          state.pagination = action.payload.paging;
        },
        rejected: (state) => {
          state.loading = false;
          state.listUserClient = [];
          state.pagination = PAGINATION;
        }
      }
    ),
    deleteUserClient: create.asyncThunk(
      async (userId: string) => {
        await apiFetcher.post(`user/client/delete`, { id: userId });
        return userId;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listUserClient = state.listUserClient.filter(
            (user) => user.userIdMnmn !== action.payload
          );
        },
        rejected: (state) => {
          state.loading = false;
        }
      }
    ),
    getListActivityLogsUserClient: create.asyncThunk(
      async (query?: Record<string, any>) => {
        const response = await apiFetcher.get('user/client/active-logs', {
          query
        });
        return response.data;
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state, action) => {
          state.loading = false;
          state.listActivityLogsUserClient = transformerArray(
            action.payload.listData
          );
          state.pagination = action.payload.paging;
        },
        rejected: (state) => {
          state.loading = false;
          state.listActivityLogsUserClient = [];
          state.pagination = PAGINATION;
        }
      }
    ),
    blockAndUnBlockUser: create.asyncThunk(
      async (query?: Record<string, any>) => {
        await apiFetcher.post('user/client/action', query);
      },
      {
        pending: (state) => {
          state.loading = true;
        },
        fulfilled: (state) => {
          state.loading = false;
        },
        rejected: (state) => {
          state.loading = false;
        }
      }
    )
  }),

  selectors: {
    watchListUserClient: (client) => client.listUserClient,
    watchListActivityLogsUserClient: (client) =>
      client.listActivityLogsUserClient,
    watchClientUserMessage: (user) => user.message,
    watchClientUserLoading: (user) => user.loading,
    watchClientUserPagination: (user) => user.pagination
  }
});

export const {
  watchListUserClient,
  watchListActivityLogsUserClient,
  watchClientUserMessage,
  watchClientUserLoading,
  watchClientUserPagination
} = clientUserSlice.selectors;

export const {
  getListUserClient,
  getListActivityLogsUserClient,
  deleteUserClient,
  blockAndUnBlockUser
} = clientUserSlice.actions;
